// extracted by mini-css-extract-plugin
export var divider = "_p0-0";
export var systemMessage = "_p0-1";
export var systemMessageWrapper = "_p0-2";